/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export type ClickInstantBookingParams = Record<string, never>;
/**
 * 発火タイミング：Instant Bookingボタン押下時（検索結果画面）
 */
export const sendGAWabunkaClickInstantBookingEvent = () => {
  sendWabunkaGAEvent('click_instant_booking_filter', {});
};
